<i18n lang='yml' src='../i18n/ExamReport.yml'></i18n>
<template>
  <div>
    <div class="exam-report">
      <div style="display: flex" class="heading-page">
        <h4 class="w-auto">{{$t('title')}}</h4>
      </div> <div class="d-flex" style="flex-wrap: wrap;">
      <span class="border-bottom heading-page">
        {{$t('location')}}: 
        <span class="spacer">{{sittingData.sub_location.name[locale]}}
        </span>
      </span>
      <span class="border-bottom heading-page">
        {{$t('date')}}: 
        <span class="spacer">
          {{formatDate(sittingData.date)}}
        </span>
      </span>
      <span class="border-bottom heading-page">
        {{$t('time')}}: 
        <span class="spacer">{{formatTime(sittingData.start_time)}}</span>
      </span>
      <span class="border-bottom heading-page w-100">
        {{$t('total_candidates')}}: 
        <span class="spacer">
          {{bookingData.length}}
        </span>
      </span>
      <span class="border-bottom heading-page w-50">
        {{$t('invigilator')}}: 
        <span class="spacer">
        </span>
      </span>
      <span class="border-bottom heading-page w-50 mr-0">
        {{$t('sign')}}
        <span class="sign-line"></span></span></div>

      <div class="exam-schedule-section" v-for="booking in bookingData" :key="booking.id">
        <div><span class="border-bottom heading-page">{{$t('candidate_section.candidate')}}</span>
          <div class="d-flex">
            <ul class="list-inline">
              <li class="list-inline-item">{{$t('candidate_section.name')}}</li><li class="list-inline-item ">
                <strong>{{booking.user_identity.first_name}} {{booking.user_identity.last_name}}</strong>
              </li>
            </ul>
          </div>
          <div class="data-wrapper">
            <ul class="list-inline w-50">
              <li class="list-inline-item">{{$t('candidate_section.sto_id')}}</li><li class="list-inline-item ">
                <strong>
                  {{booking.user_identity.external_identifiers && booking.user_identity.external_identifiers.sto_id ? booking.user_identity.external_identifiers.sto_id : "N/A"}}
                </strong>
              </li>
            </ul>
            <ul class="list-inline w-50">
              <li class="list-inline-item">{{$t('candidate_section.sin')}}</li>
              <li class="list-inline-item "><strong>{{booking.user_identity.external_identifiers ? booking.user_identity.external_identifiers.substitute_identifier : 'N/A'}}</strong></li>
            </ul>
            <ul class="list-inline w-50">
              <li class="list-inline-item">{{$t('candidate_section.phone_number')}}</li>
              <li class="list-inline-item ">
                <strong>{{booking.user_identity.phone_number}}</strong>
              </li>
            </ul>
            <ul class="list-inline w-50">
              <li class="list-inline-item">{{$t('candidate_section.language')}}</li>
              <li class="list-inline-item "><strong>{{booking.language}}</strong></li>
            </ul>
            <ul class="list-inline w-50">
              <li class="list-inline-item">{{$t('candidate_section.times_previously_written')}}</li><li class="list-inline-item ">
                <strong>{{booking.times_previously_written}}</strong>
              </li>
            </ul>
            <ul class="list-inline w-50" style="">
              <li class="list-inline-item">{{$t('id_checked')}}</li>
              <li class="list-inline-item ">
                <strong class="check-box">☐</strong>
              </li>
            </ul>
            <ul class="list-inline w-50">
              <li class="list-inline-item">{{$t('candidate_section.last_version_written')}}</li>
              <li class="list-inline-item "><strong>{{booking.previous_version_written || "N/A"}}</strong></li>
            </ul>
          </div>
        </div>
        <div><span class="border-bottom heading-page">{{$t('exam_section.exam')}}</span>
          <div class="d-flex">
            <ul class="list-inline">
            <li class="list-inline-item">{{$t('exam_section.toss')}}</li>
            <li class="list-inline-item "><strong>{{booking.training_program.trade_code}} - {{booking.training_program.name[locale]}}</strong>
          </li></ul>
          </div><div class="data-wrapper">
            <ul class="list-inline w-100">
            <li class="list-inline-item">{{$t('exam_section.exam_code')}}</li><li class="list-inline-item "><strong>{{booking.test_id}}</strong>
          </li></ul><ul class="list-inline w-100">
            <li class="list-inline-item">{{$t('exam_section.version')}}</li><li class="list-inline-item "><strong>-</strong>
          </li></ul><ul class="list-inline w-100">
            <li class="list-inline-item">{{$t('exam_section.exam_book')}}</li><li class="list-inline-item "><strong>-</strong>
          </li></ul>
        </div></div>
    
        <div class="accommodation-request w-100" v-if="booking.booking_accommodations.length > 0">
          <span class="border-bottom heading-page">{{$t('accommodation_section.request')}}</span>
          <div v-for="accommodation in booking.booking_accommodations" :key="accommodation.id">
            <div class="data-wrapper">
              <ul class="list-inline w-33">
                <li class="list-inline-item">{{$t('accommodation_section.type')}}</li>
                <li class="list-inline-item ">
                  <strong>{{$t(`accommodation_types.${accommodation.accommodation_type}`)}}</strong>
                </li>
              </ul>
              <ul class="list-inline w-33">
                <li class="list-inline-item">{{$t('accommodation_section.status')}}</li>
                <li class="list-inline-item ">
                  <strong>{{$t(`accommodation_statuses.${accommodation.status}`)}}</strong>
                </li>
              </ul>
            </div>
            <div class="data-wrapper" v-if="accommodation.accommodation_type == 'scribe'">
              <ul class="list-inline w-33">
                <li class="list-inline-item">{{$t('accommodation_section.sir_name')}}</li>
                <li class="list-inline-item ">
                  {{booking.sir_name}}
                </li>
              </ul>
              <ul class="list-inline  w-33">
                <li class="list-inline-item">{{$t('accommodation_section.sir_id')}}</li>
                <li class="list-inline-item ">
                  {{booking.sir_id}}
                </li>
              </ul>
              <ul class="list-inline w-33">
                <li class="list-inline-item">{{$t('id_checked')}}</li>
                <li class="list-inline-item ">
                  <strong class="check-box">☐</strong>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="comments-accommodation w-100">
          <span class="border-bottom heading-page">{{$t('comments')}}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {formatDate, formatTime} from '../../shared/typescripts/dates.ts'
  export default {
    props: [
      'locale',
      'base_path',
      'sitting',
      'pagination_limit',
      'time_format_en',
      'time_format_fr'
    ],

    data() {
      return {
        sittingData: {},
        bookingData: []
      }
    },

    mounted() {
      this.$i18n.locale = this.locale;
      this.sittingData = JSON.parse(this.sitting);
      this.bookingData = JSON.parse(this.sittingData.sort_bookings_by_training_program);
    },

    methods: {
      formatDate(dateString) {
        return formatDate(dateString)
      },

      formatTime: function (date) {
        let format = this.locale == 'en' ? this.time_format_en : this.time_format_fr
        return formatTime(date, format)
      },
    }
}
</script>
